import { Component } from '@angular/core';

@Component({
  selector: 'ptl-skeleton-table-item',
  templateUrl: './skeleton-table-item.component.html',
  styleUrls: ['./skeleton-table-item.component.scss'],
})
export class SkeletonTableItemComponent {}
